var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5232 3.14713e-05L14.5232 14.5103H16L16 3.14713e-05H14.5232Z",
    fill: "#BFFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2174 0.692379L0 14.021L1.04427 15L15.2616 1.67137L14.2174 0.692379Z",
    fill: "#BFFF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L0.522217 0L0.522217 1.38452L16 1.38452V0Z",
    fill: "#BFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.88846e846efca8b2315125f9a9770c71.svg";
export { ForwardRef as ReactComponent };